import { VisitPublicApi } from 'woofwoof-api-public';
import client, { publicAxiosBaseUrl } from './client';
export const publicVisitApi = new VisitPublicApi(
  {
    basePath: publicAxiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
